import { render, staticRenderFns } from "./emojiDetail.vue?vue&type=template&id=44342a4f&scoped=true"
import script from "./emojiDetail.vue?vue&type=script&lang=js"
export * from "./emojiDetail.vue?vue&type=script&lang=js"
import style0 from "./emojiDetail.vue?vue&type=style&index=0&id=44342a4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44342a4f",
  null
  
)

export default component.exports